import {charcoal} from '../sass/base/_exports.sass';

export const DeleteIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 16;
  const height = 16;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3335 2.99967H13.6668V4.33301H12.3335V12.9997C12.3335 13.1765 12.2633 13.3461 12.1382 13.4711C12.0132 13.5961 11.8436 13.6663 11.6668 13.6663H2.3335C2.15668 13.6663 1.98712 13.5961 1.86209 13.4711C1.73707 13.3461 1.66683 13.1765 1.66683 12.9997V4.33301H0.333496V2.99967H3.66683V0.999674C3.66683 0.822863 3.73707 0.653294 3.86209 0.52827C3.98712 0.403246 4.15668 0.333008 4.3335 0.333008H9.66683C9.84364 0.333008 10.0132 0.403246 10.1382 0.52827C10.2633 0.653294 10.3335 0.822863 10.3335 0.999674V2.99967ZM11.0002 4.33301H3.00016V12.333H11.0002V4.33301ZM5.00016 1.66634V2.99967H9.00016V1.66634H5.00016Z"
        fill={color}
      />
    </svg>
  );
};
